export enum ApplicantStatus {
  DETAILS_FORM = "details-form",
  MTG_BOOKING = "mtg-booking",
  MTG_BOOKED = "mtg-booked",
  MTG_CANCELLED = "mtg-cancelled",
  PENDING_PAYMENT = "pending-payment",
  PENDING_FULL_PAYMENT = "pending-full-payment",
  PAID_IN_FULL = "paid-in-full",
}

export enum MeetingVariant {
  ONE = "one",
  MANY = "many",
}

export interface ApplicantCohort {
  _id: string;
  number: number;
  startDate: string;
}

export interface Applicant {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  linkedinUrl: string;
  phoneNumber?: string;
  status: ApplicantStatus;
  meetingVariant: MeetingVariant;
  bookingUid?: string;
  cohort?: ApplicantCohort;
  stripeCustomerId?: string;
  licenseeId?: string;
  // Marketing tracking data
  utmSource?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  as?: string; // Ad set
  lpv?: string; // Landing page version
  // Attio CRM tracking
  attioRecordId?: string;
  attioEntryId?: string;
  // Timestamps
  createdAt: string;
  updatedAt: string;
}

// Helper function to get status label
export const getApplicantStatusLabel = (status: ApplicantStatus): string => {
  const labels: Record<ApplicantStatus, string> = {
    [ApplicantStatus.DETAILS_FORM]: "New lead",
    [ApplicantStatus.MTG_BOOKING]: "Completed application",
    [ApplicantStatus.MTG_BOOKED]: "Meeting scheduled",
    [ApplicantStatus.MTG_CANCELLED]: "Meeting canceled",
    [ApplicantStatus.PENDING_PAYMENT]: "Pending payment",
    [ApplicantStatus.PENDING_FULL_PAYMENT]: "Paid (deposit)",
    [ApplicantStatus.PAID_IN_FULL]: "Paid (full payment)",
  };
  return labels[status] || status;
};

// Helper function to get meeting variant label
export const getMeetingVariantLabel = (variant: MeetingVariant): string => {
  const labels: Record<MeetingVariant, string> = {
    [MeetingVariant.ONE]: "One-on-One",
    [MeetingVariant.MANY]: "Group",
  };
  return labels[variant] || variant;
};

// Helper function to get status color for badges
export const getApplicantStatusColor = (
  status: ApplicantStatus,
): "purple" | "blue" | "green" | "yellow" | "red" | "lightGrey" => {
  switch (status) {
    case ApplicantStatus.PAID_IN_FULL:
      return "green";
    case ApplicantStatus.PENDING_FULL_PAYMENT:
      return "blue";
    case ApplicantStatus.MTG_BOOKED:
      return "purple";
    case ApplicantStatus.PENDING_PAYMENT:
      return "yellow";
    case ApplicantStatus.MTG_CANCELLED:
      return "red";
    case ApplicantStatus.DETAILS_FORM:
    case ApplicantStatus.MTG_BOOKING:
      return "lightGrey";
    default:
      return "lightGrey";
  }
};

// Helper function to get meeting variant color for badges
export const getMeetingVariantColor = (
  variant: MeetingVariant,
): "purple" | "blue" => {
  switch (variant) {
    case MeetingVariant.ONE:
      return "purple";
    case MeetingVariant.MANY:
      return "blue";
    default:
      return "blue";
  }
};
